var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_a185e16e"]},_vm.$listeners),[_c('cube-button',[_vm._v("默认按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }